import script from "./PaginationInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationInfo.vue?vue&type=script&setup=true&lang=js"

import "./PaginationInfo.vue?vue&type=style&index=0&id=d587f62a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d587f62a"]])

export default __exports__